var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{key:`lang-${_vm.i}`,attrs:{"label":"","items":_vm.langs,"density":"comfortable","background-color":"transparent","append-icon":"mdi-translate"},on:{"change":_vm.changeLang},model:{value:(_vm.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$i18n, "locale", $$v)},expression:"$i18n.locale"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }